import clsx from 'clsx/lite'

const MenuTitle = (props) => (
  <div {...props} className={clsx(props.className, 'menu-title')} />
)

export default MenuTitle
